/**
 * Adds an item to an array if it's not present, or removes it if it is.
 * Returns a new array without mutating the original.
 */
export function toggleInArray<T>(arr: T[], item: T): T[] {
  return arr.includes(item) ? arr.filter((v) => v !== item) : [...arr, item];
}
